import { Link } from 'react-router-dom';
import { servicesData } from '../../../mocks/services';

const ServicesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-end mb-16">
          <div className="text-orange-500 text-sm font-sans font-semibold tracking-wider">
            /OUR EXPERTISE
          </div>
          <div className="text-right">
            <h2 className="font-montserrat font-bold text-5xl text-gray-900 mb-2">
              Comprehensive Tax Services
            </h2>
            <p className="text-gray-600 font-sans text-lg">Tailored to Your Needs</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className="group bg-cream-100 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer relative overflow-hidden"
            >
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-orange-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 rounded-2xl mb-6 group-hover:bg-orange-500 transition-colors">
                <i className={`${service.icon} text-3xl text-orange-500 group-hover:text-white transition-colors`}></i>
              </div>

              <h3 className="font-montserrat font-bold text-xl text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 font-sans text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-orange-500 text-white px-8 py-4 rounded-full font-sans font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
